import { render, staticRenderFns } from "./InserirDocumentos.vue?vue&type=template&id=6b6d2052"
import script from "./InserirDocumentos.vue?vue&type=script&lang=js"
export * from "./InserirDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports